import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

interface InfoBadgeProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  isDark: boolean;
  variant: 'success' | 'info';
}

export const InfoBadge: React.FC<InfoBadgeProps> = ({ icon, children, isDark, variant }) => {
  const theme = useTheme();
  const bgColor = variant === 'success' 
    ? (isDark ? 'rgba(240, 255, 240, 0.1)' : 'rgba(240, 255, 240, 0.8)')
    : (isDark ? 'rgba(240, 248, 255, 0.1)' : 'rgba(240, 248, 255, 0.8)');

  return (
    <Typography
      sx={{
        fontSize: '0.8125rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        bgcolor: bgColor,
        border: `1px solid ${isDark ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
        px: 1.5,
        py: 0.625,
        borderRadius: 1,
        letterSpacing: '0.01em',
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 0.625,
        lineHeight: 1.2,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Box sx={{ 
        display: 'inline-flex', 
        alignItems: 'flex-start',
        fontSize: '1.1em',
        lineHeight: 1,
        transform: 'translateY(0.1em)'
      }}>
        {icon}
      </Box>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
        {children}
      </Box>
    </Typography>
  );
}; 